import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';
import { useAuth } from '../lib/useAuth';
import type { TrendRound } from '../redesign/live/behaviorTrend';

export const BEHAVIOR_TREND_QUERY_KEY = ['behavior-trend', 2] as const;
export type BehaviorTrendResponse = { rounds: TrendRound[]; skipped?: number };

/** 홈·상세가 계정별 캐시를 공유한다. 재진입 때 자동 복기 결과도 다시 읽는다. */
export function useBehaviorTrend() {
  const { user } = useAuth();
  return useQuery({
    queryKey: [...BEHAVIOR_TREND_QUERY_KEY, user?.id ?? 'guest'],
    queryFn: async (): Promise<BehaviorTrendResponse> => {
      const data = await apiFetch<BehaviorTrendResponse>('/api/mobile/sim/review?trend=2', { cache: 'no-store' });
      if (!Array.isArray(data?.rounds)) throw new Error('습관 기록 응답 형식 오류');
      return data;
    },
    staleTime: 0,
    retry: false, // apiFetch가 전송 실패를 재시도한다.
  });
}
